import React, { useContext } from "react";
import "./Vision.css";
import { LanguageContext } from "../../context/LanguageContext";

const Vision = () => {
  const { language } = useContext(LanguageContext); // Get the current language

  const visionText = language === "ar"
    ? `إدارة الشركات التابعة لها أو المشاركة في إدارة الشركات الأخرى التي تساهم فيها وتقديم الدعم اللازم لها، وملكية حقوق الملكية الصناعية لبراءات الاختراع والعلامات التجارية والصناعية وحقوق الامتياز، وغيرها من الحقوق المعنوية واستغلالها وتأجيرها لشركاتها التابعة أو للغير.`
    : `Manage its subsidiaries or participation in the management of other companies in which it contributes and provide the necessary support for them and the ownership of industrial property rights of patents, trademarks and industrial and the rights of the franchise and other moral rights and exploitation and lease to its subsidiaries or others.`;

  return (
    <div className="vision-page" dir={language === "ar" ? "rtl" : "ltr"}>
      <div key={language} className="fade-transition">
        <h2 className="vision-title">
          {language === "ar" ? "رؤيتنا" : "Our Vision"}
        </h2>

        {/* Card layout with background effect */}
        <div className="vision-card-container">
          <div className="vision-background"></div>
          <div
            className="vision-card"
            dir={language === "ar" ? "rtl" : "ltr"}
            style={{ textAlign: language === "ar" ? "right" : "left" }}
          >
            <p>{visionText}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Vision;
